
import { Options, Vue } from 'vue-class-component';
import { ProviderPortalClient } from '@/services/DueDiligenceServices';
import * as DDM from '@/dueDiligenceModels';
import store from '@/store';

@Options({})
export default class ProviderSurveyResults extends Vue {

    template: DDM.SurveyTemplate = new DDM.SurveyTemplate();
    response: DDM.SurveyResponse = null;
    loaded: boolean = false;
    factorySummaries: DDM.FactorySurveySummary[] = [];
    selectedFactoryId: string = "";

    get culture(): string {
        return store.state.loggedUser?.preferredCulture || "en-US";
    }

    get submittedFactories(): DDM.FactorySurveySummary[] {
        return this.factorySummaries.filter(f => f.responseStatus === DDM.SurveyResponseStatus.Submitted);
    }

    created() {
        this.init();
    }

    init() {
        ProviderPortalClient.getSurvey(undefined)
        .then(x => {
            this.template = x.template;
            this.factorySummaries = x.factorySummaries || [];

            // Auto-select first submitted factory
            let submitted = this.submittedFactories;
            if (submitted.length > 0) {
                this.selectedFactoryId = submitted[0].factoryId;
                this.loadFactoryResponse();
            } else if (x.response && x.response.status === DDM.SurveyResponseStatus.Submitted) {
                // Legacy: no factories
                this.response = x.response;
                this.loaded = true;
            } else {
                this.$router.replace('/provider/survey');
            }
        });
    }

    onFactoryChange() {
        if (this.selectedFactoryId) {
            this.loadFactoryResponse();
        }
    }

    loadFactoryResponse() {
        ProviderPortalClient.getSurvey(this.selectedFactoryId, false)
        .then(x => {
            this.response = x.response;
            this.loaded = true;
        });
    }

    getLocalized(ls: DDM.LocalizedString): string {
        if (!ls || !ls.values) return "";
        return ls.values[this.culture] || ls.values["en-US"] || Object.values(ls.values)[0] || "";
    }

    isQuestionVisible(question: DDM.SurveyQuestion): boolean {
        if (!question || !question.conditionalOnQuestionId) return true;
        if (!this.response || !this.response.answers) return true;
        return DDM.isConditionalMet(question.conditionalOnQuestionId, this.response.answers);
    }

    getAnswerValue(questionId: string, subQuestionId: string): string {
        if (!this.response) return "";
        let answer = this.response.answers.find(a => a.questionId === questionId && a.subQuestionId === (subQuestionId || ""));
        return answer ? answer.response : "";
    }

    getAnswerInfo(questionId: string, subQuestionId: string): string {
        if (!this.response) return "";
        let answer = this.response.answers.find(a => a.questionId === questionId && a.subQuestionId === (subQuestionId || ""));
        return answer ? answer.informationalText : "";
    }

    getAnswerEvidence(questionId: string, subQuestionId: string): boolean {
        if (!this.response) return false;
        let answer = this.response.answers.find(a => a.questionId === questionId && a.subQuestionId === (subQuestionId || ""));
        return answer ? answer.evidenceAvailable === true : false;
    }

    getCertSelected(questionId: string, certificationId: string): boolean {
        if (!this.response) return false;
        let answer = this.response.answers.find(a => a.questionId === questionId && a.subQuestionId === "");
        if (!answer) return false;
        return answer.certificationSelections.some(c => c.certificationId === certificationId && c.selected);
    }

    getAnswerClass(value: string): string {
        switch (value) {
            case "yes": return "answer-yes";
            case "partially": return "answer-partially";
            case "no": return "answer-no";
            default: return "answer-none";
        }
    }

    getRedFlag(flagType: DDM.RedFlagType, response: string): { label: string; cssClass: string } | null {
        return DDM.getTriggeredRedFlag(flagType, response);
    }
}
